import * as types from '@store/types'
import request from '@queries'
import TransactionsQuery from '@queries/Transactions'
import axios from 'axios'
import utils from '../utils/awards'

const state = {
  engagementCampaigns: [],
  engagementPartners: [],
  engagementOptions: {
    page: 1,
    current_page: 1,
    limit: 18,
    total: 0
  },
  coin: {
    program_name: '',
    program_image: ''
  }
}

const getters = {
  [types.COIN]: ({ coin }) => ({ ...coin }),
  [types.ENGAGEMENT_CAMPAIGNS]: (state) => state.engagementCampaigns,
  [types.ENGAGEMENT_PARTNERS]: (state) => state.engagementPartners,
  [types.ENGAGEMENT_OPTIONS]: (state) => state.engagementOptions
}

const mutations = {
  [types.ENGAGEMENT_PARTNERS]: (state, payload) => {
    state.engagementPartners = payload
  },
  [types.ENGAGEMENT_CAMPAIGNS]: (state, payload) => {
    state.engagementCampaigns = payload
  },
  [types.COIN]: (state, payload) => {
    state.coin = payload
  },
  [types.ENGAGEMENT_OPTIONS]: (state, payload) => {
    state.engagementOptions = payload
  }
}

const actions = {
  [types.GET_ENGAGEMENT_CAMPAIGNS]: async ({ commit }) => {
    const response = await axios.get('partners/engagement/campaigns?limit=18')
    const campaigns = (response.data.data)

    commit(types.ENGAGEMENT_CAMPAIGNS, campaigns)
    return campaigns
  },

  [types.GET_ENGAGEMENT_PARTNERS]: async ({ commit }) => {
    const response = await axios.get('partners/engagement?limit=18')
    const partners = (response.data.data)
    const options = {
      ...response.data.meta,
      page: 1,
      limit: 18
    }
    commit(types.ENGAGEMENT_PARTNERS, partners)
    commit(types.ENGAGEMENT_OPTIONS, options)
    return partners
  },

  [types.FIND_ENGAGEMENT_PARTNER]: async ({}, payload) => {
    const response = await axios.get(`partners/engagement?slug=${payload.partnerSlug}`)
    const partner = response.data.data[0]
    if (partner && partner.campaigns && partner.campaigns.length > 1) {
      partner.campaigns = [{
        ...partner.campaigns[0],
        eventData: {
          max_value: utils.formatAwardValues(partner.campaigns).maxValue,
          min_value: utils.formatAwardValues(partner.campaigns).minValue,
          prices_options: utils.formatAwardValues(partner.campaigns).priceOptions,
          value: null
        },
        campaigns_reduced: utils.reduceCampaigns(partner.campaigns)
      }]
    }
    return partner
  },

  [types.GET_ENGAGEMENT_INCREASE]: async ({ commit, getters }, payload = {}) => {
    const { total } = getters[types.ENGAGEMENT_OPTIONS]
    const partners = getters[types.ENGAGEMENT_PARTNERS]

    if (partners.length >= total) return true

    let options = getters[types.ENGAGEMENT_OPTIONS]

    options = {
      ...options,
      ...payload,
      current_page: options.current_page + 1,
      page: options.page + 1
    }

    commit(types.ENGAGEMENT_OPTIONS, options)

    const { data } = await axios.get(`partners/engagement?page=${options.current_page}&limit=${options.limit}`)

    commit(types.ENGAGEMENT_PARTNERS, [
      ...partners,
      ...data.data
    ])
  },

  [types.GET_COIN]: async ({ commit, dispatch }) => {
    try {
      const response = await axios.get('/engagement/coin')
      if (response && response.data && response.data.data) {
        commit(types.COIN, response.data.data)
      } else {
        dispatch(types.FEEDBACK, {
          type: 'error',
          title: 'Houve um erro ao pegar os dados da moeda, por favor, tente novamente mais tarde',
          text: ''
        })
      }
    } catch (error) {
      dispatch(types.FEEDBACK, {
        type: 'error',
        title: 'Houve um erro ao pegar os dados da moeda, por favor, tente novamente mais tarde',
        text: ''
      })
    }
  },

  [types.ENGAGEMENT_RESCUE]: async ({ dispatch }, payload) => {
    try {
      const response = await axios.post(`/campaign/${payload.id}/event`, { value: payload.value })
      return response.data
    } catch (err) {
      dispatch(types.FEEDBACK, {
        type: 'error',
        title: 'Houve um erro ao resgatar a oferta, por favor, tente novamente mais tarde',
        text: ''
      })
      return { success: false }
    }
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/engagement.js